import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { billingLogoUrl } from '../../config/branding';

export function AuthLoading() {
  return (
    <Box className="auth-loading">
      <Box className="auth-loading-card">
        <img
          src={billingLogoUrl}
          alt="Facturación de Expediciones"
          className="auth-loading-logo"
        />
        <Typography className="auth-loading-title">Comprobando sesion</Typography>
        <LinearProgress className="auth-loading-progress" />
      </Box>
    </Box>
  );
}

function ProtectedRoute({ authChecked, session, children }) {
  if (!authChecked) {
    return <AuthLoading />;
  }

  if (!session) {
    return <Navigate replace to="/login" />;
  }

  return children;
}

export default ProtectedRoute;
